import React, { useEffect, useState } from 'react';
import { LoadingOverlay } from '@mantine/core';
import { createPortal } from 'react-dom';
import clsx from 'clsx';
import AuroraLoader from '../AuroraLoader';
import { usePortalTarget } from '../../provider/UiContext';
import './BackdropLoader.scss';

export interface IBackdropLoaderProps {
    className?: string;
    /** Подпись под кольцом (анимированные точки добавляются автоматически). */
    label?: string;
}

/** Сколько лоадеров держат прокрутку body и какой она была до первого: лоадеры снимаются в любом порядке,
 *  а body возвращается к своему значению, только когда закрылся последний. */
let scrollLocks = 0;
let bodyOverflowY = '';

function lockBodyScroll(): () => void {
    if (scrollLocks++ === 0) {
        bodyOverflowY = document.body.style.overflowY;
        document.body.style.overflowY = 'hidden';
    }
    return () => {
        if (--scrollLocks === 0) document.body.style.overflowY = bodyOverflowY;
    };
}

// Фасад на Mantine LoadingOverlay: оверлей/подложку рисует Mantine, лоадер —
// по-прежнему фирменный AuroraLoader (loaderProps.children). Фуллскрин достигается
// position:fixed на руте (SCSS) — LoadingOverlay по умолчанию облегает positioned-родителя.
// Портал в отдельный div и скролл-лок body — ручные, как в легаси (Mantine их не даёт). Div — в хосте порталов
// области (тема дизайнера), иначе в body; один на всё время жизни лоадера.
const BackdropLoader: React.FC<IBackdropLoaderProps> = ({ className = '', label }: IBackdropLoaderProps) => {
    const portalTarget = usePortalTarget();
    const [div] = useState(() => document.createElement('div'));

    useEffect(() => {
        (portalTarget ?? document.body).appendChild(div);
        return () => div.remove();
    }, [div, portalTarget]);

    useEffect(() => lockBodyScroll(), []);

    const loader = (
        <LoadingOverlay
            visible
            className={clsx('jf-backdrop-loader', className)}
            zIndex={1000}
            transitionProps={{ duration: 0 }}
            overlayProps={{ color: 'var(--surface)', backgroundOpacity: 0.8, blur: 0 }}
            loaderProps={{ children: <AuroraLoader size="xl" label={label} /> }}
        />
    );
    // -------------------------------------------------------------------------------------------------------------------

    return createPortal(loader, div);
};

export default BackdropLoader;
